// import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import Home from "../Templates/Home";
import FinalCart from "../CheckItem/finalcart/FinalCart";
import PoeSwitches from "../Templates/PoeSwitches";
import Nvr from "../Templates/nvrrecorder/Nvr";
import Cameras from "../Templates/Cameras";
import Cabling from "../Templates/Cabling";
import Hardware from "../Templates/Hardware";
import NoFound from "../Templates/NoFound";
import Cart from "../Templates/Cart";
import Special from "../Templates/Special";

import NavBar from "../../Component/Header/NavBaR";
import Labor from "../Templates/Labor";
import TemplateA from "../Templates/TemplateA";
import WarningComponent from "../Templates/WarningComponent";
import Print from "../Templates/Print";

function RoutesMiddleware() {
  return (
    <div className="Routes">
      {/* <BrowserRouter> */}
      <Router> {/* This is HashRouter */}
        <NavBar />
        <WarningComponent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nvr" element={<Nvr />} />
          <Route path="/cameras" element={<Cameras />} />
          <Route path="/hardware" element={<Hardware />} />
          <Route path="/cabling" element={<Cabling />} />
          <Route path="/labor" element={<Labor />} />
          <Route path="/add_to_cart" element={<FinalCart />} />
          <Route path="/poe-switch" element={<PoeSwitches />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/special" element={<Special />} />
          <Route path="/templatea" element={<TemplateA />} />
          <Route path="/print" element={<Print />} />

          {/* Add the 404 route at the end */}
          {/* <Route path="*" element={<NoFound />} /> */}
          {/* <Route path="*" element={<Home />} /> */}
        </Routes>
      </Router>
      {/* </BrowserRouter> */}
    </div>
  );
}

export default RoutesMiddleware;
